export default "__VITE_ASSET__16989105__"